import {NoopScrollStrategy} from '@angular/cdk/overlay';

export function SCROLL_STRATEGY_PROVIDER_FACTORY() {
  return () => new NoopScrollStrategy();
}



// WEBPACK FOOTER //
// ./src/app/scroll-strategy.ts